type SpinnerProps = {
  visible?: boolean;
  size?: "small" | "big";
};

export default function Spinner({ visible = false, size = "small" }: SpinnerProps) {
  if (!visible) {
    return null;
  }

  const sizeClass = size === "small" ? "h-5 w-5" : "h-10 w-10";

  return (
    <div className="flex items-center justify-center">
      <svg
        className={sizeClass}
        style={{ animation: "spin 1s linear infinite" }}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-100"
          cx="12"
          cy="12"
          r="10"
          stroke="#f0e7ff" // Tailwind purple-100
          strokeWidth="2"
        ></circle>
        <circle
          className="opacity-75"
          cx="12"
          cy="12"
          r="10"
          stroke="#7a4cb7" // Tailwind purple-600
          strokeWidth="2"
          strokeDasharray="60"
          strokeDashoffset="20"
          fill="none"
        ></circle>
      </svg>
      <style>
        {`
          @keyframes spin {
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}